
import { Component, Vue, Prop, Watch, Emit } from "vue-property-decorator";
import { isMobile, isTablet, isIE } from "mobile-device-detect";
import Slick from "vue-slick";
import LazyImage from "./../LazyImage.vue";
import { apiFetchLotInfo } from "../../api";
import { HomesPlan, LotDetail, LotInfo, LotPosition, NeighborhoodInfo } from "./../../types";
import { Status, ModalType, Scalers, LinkOpenConatactInfo } from "./../../constant";
import Location from "@/assets/icons/Location.vue";
import {
  calcZoom,
  formatPrice,
  getPlatMapModalPosition,
  convertToTitleCase,
  getTouchesCenter,
  getZoomDistance,
  addImageScaler,
} from "./../../core";
import { apiMessages } from "../../api/message-api";
@Component({
  components: {
    Slick,
    LazyImage,
    Location
  },
})
export default class PlatMapModal extends Vue {
  $refs!: any;
  $route!: any;
  sliderOptions: any = {
    slidesToShow: 1,
    infinite: false,
  };
  private availableStatus = Status;
  private lotInfo: LotInfo = {} as LotInfo;
  private selectedTab = 1;
  private hasMobile = !!(isMobile && !isTablet);
  private hasTablet = isTablet;
  private lotPosition: LotPosition = {} as LotPosition;
  private errorMessage = "";
  private loading = isIE;
  private messages: any = {};
  private trailingText = [] as Array<string>
  private linkOpenConatactInfo = LinkOpenConatactInfo;
  private zoom = 1;
  private zoomCenter = {
    x: 0,
    y: 0,
  };
  private lastDistance = 0;
  private minZoomBounce = 0.015;
  private maxZoomBounce = 0.015;
  private width = window.innerWidth;
  private height = window.innerHeight;
  private lastX = null as any;
  private lastY = null as any;
  private x = 0;
  private y = 0;
  private transition = {
    transform: null as any,
    origin: "transform-origin 400ms linear" as any,
  };
  private minZoom = 1;
  private maxZoom = 10;
  private speed = 0.5;
  private showDefaultImage = false;
  @Prop() private lotId!: string;
  @Prop() private neighborhoodId!: string;
  @Prop() private position!: LotPosition;
  @Prop() private isKioskMode!: boolean;
  @Prop() private selectedNeighborhoodIds!: string[];
  @Prop() private neighborhoods!: NeighborhoodInfo[];
  @Prop() private zoomLevel!: number;
  @Prop() private underlay!: boolean

  @Emit("showPlanFutureLotFlyout")showPlanFutureLotFlyout(lotInfo: LotInfo, lotId: string){}

  @Emit("openModal") openModal(modalName: string) {}

  @Emit("calculateContactInfoTopPosition") calculateContactInfoTopPosition() {}

  @Emit("updateLotPosition") updateLotPosition(lotPosition: LotPosition) {}

  @Emit("handlePrintSelectionClick") handlePrintSelectionClick(
    printOptionSelected: boolean
  ) {}

  @Emit("updateLotInfo")updateLotInfo(lotDetail: LotInfo|LotDetail, lotId: string){}

  @Emit("closeLotInfo") handleClose() {}

  @Watch("lotId")
  async onLotIdChanged(val: string, oldVal: string) {
    if (val !== oldVal) {
      this.resetZoom();
      await this.fetchLotInfo();
      if(!this.underlay)
        this.resetModalTop();
    }
  }

  @Watch("selectedNeighborhoodIds")
  onNeighborhoodIdChanged(val: string[], oldVal: string[]) {
    if (val !== oldVal) {
      this.handleClose();
    }
  }

  @Watch("position")
  handlePositionChange(val: LotPosition, oldVal: LotPosition) {
    if (!this.lodash.isEqual(val, oldVal)) {
      this.lotPosition = val;
    }
  }

  get showHomePlanLabel() {
    return this.lotInfo.homes_plans.length && [this.availableStatus.AVAILABLE, this.availableStatus.FUTURE_HOME].includes(this.lotInfo.lot.status);
  }
  constructor() {
    super();
    this.loadMessages();
  }
  
  get isShowModalAboveArrowUnderlay(){
    return !this.underlay && (this.hasMobile || this.hasTablet) && this.lotPosition.positionModal === 'below'
  }

  get isShowModalDownArrowUnderlay(){
    return !this.underlay && (this.hasMobile || this.hasTablet) && this.lotPosition.positionModal === 'above'
  }
  convertToTitleCase(value: string) {
    return convertToTitleCase(value);
  }
  isResetModalTopPosition(){
    return (this.lotInfo && this.lotPosition.positionModal === 'above') && (!this.lotInfo.homes_plans.length || !this.lotInfo.homes_plans[0].image_url.length)
  }
  resetModalTop(){
    if(this.isResetModalTopPosition()){
      this.lotPosition.top += 230;
    }
  }
  async loadMessages() {
    const { messages } = await apiMessages("PlatMapModal");
    this.messages = messages;
    this.trailingText = this.messages.soldHomesMessage.split(this.linkOpenConatactInfo);
  }

  async mounted() {
    this.lotPosition = this.position;
    await this.fetchLotInfo();
    if(!this.underlay)
      this.resetModalTop();
  }

  updated() {
    this.$nextTick(function () {
      if (isIE && this.$refs.slick) {
        this.loading = false;
      }
      if (!this.lodash.isEmpty(this.lotInfo) && !isMobile && !isTablet) {
        this.updateModalPosition();
      }
    });
  }

  handleReInit() {
    this.$nextTick(() => {
      this.$refs.slick.reSlick();
    });
  }

  handleSiteReInit() {
    this.$nextTick(() => {
      this.$refs.siteSlick.reSlick();
    });
  }

  beforeClose() {
    this.lotInfo = {} as LotInfo;
    let timer = setTimeout((_) => {
      this.handleClose();
      clearTimeout(timer);
    }, 10);
  }

  beforeDestroy() {
    const el = this.$refs.baseElement;
    if (el) {
      el.removeEventListener("touchstart", this.start);
      el.removeEventListener("touchmove", this.move);
      el.removeEventListener("touchend", this.end);
    }
    if(!this.underlay && this.hasMobile){
      document.querySelector('.embtoolbox')?.classList.toggle('mobhide');
      document.querySelector('.mobile-legends')?.classList.toggle('mobhide');
      document.querySelector('.cp-filter')?.classList.toggle('mobhide');
    }
  }

  async fetchLotInfo() {
    this.lotInfo = {} as LotInfo;
    let lotNeighborhood = '';
    let currentLotNeighborhoodId = this.lotId.split('-')[0];
    const data = await apiFetchLotInfo(currentLotNeighborhoodId, this.lotId);
      if (data.result.lot.id === this.lotId) {
        lotNeighborhood = this.neighborhoods.find(neighborhood => neighborhood.neighborhood_code === currentLotNeighborhoodId)?.marketing_name || '';
        if (data.message) {
          this.errorMessage = "Information for this lot is not yet available";
        } else {
          const { result } = data;
          this.lotInfo = result;
          this.lotInfo.neighborhoodName = lotNeighborhood;
          this.errorMessage = "";
          this.showPlanFutureLotFlyout(this.lotInfo, this.lotId);
        }
      }
      this.updateLotInfo(this.lotInfo,this.lotId);
  }

  formatPrice(value) {
    return formatPrice(value);
  }

  formatSquareFeet(x) {
    return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  }
  formatDate(moveInDate: string) {
    let date = new Date(moveInDate);
    let formattedDate = date.toDateString().split(" ");
    return `${formattedDate[1]} ${formattedDate[2]}, ${formattedDate[3]}`;
  }
  get lotStatus() {
    let status = this.lotInfo.lot.status;
    if ([this.availableStatus.QUICK_MOVE_IN].includes(status)) status = "qmi";
    else if (
      [this.availableStatus.SOLD, this.availableStatus.AVAILABLE].includes(
        status
      )
    )
      status = status.toLowerCase();
    return status;
  }

  get showFutureHomePlanLabel() {
    return this.lotInfo.homes_plans.length && [this.availableStatus.FUTURE_HOME].includes(this.lotInfo.lot.status);
  }

  openPlanDetails(planURL: Location) {
    window.open(`${planURL}`, `HomePlans_WindowName`);
  }
  openKioskPlanView(planCode: number) {
    let kioskPlanLink = `${process.env.VUE_APP_KIOSK_URL}planView?`;
    if (this.lotStatus === this.availableStatus.AVAILABLE.toLowerCase()) {
      kioskPlanLink += `plan_code=${planCode}&neighborhood_code=${this.selectedNeighborhoodIds[0]}`;
    } else if (this.lotStatus === 'qmi') {
      kioskPlanLink += `job_number=${this.lotInfo.lot.id}&neighborhood_code=${this.selectedNeighborhoodIds[0]}`;
    }
    window.open(`${kioskPlanLink}`, `HomePlans_WindowName`);
  }

  openContactInfo() {
    this.calculateContactInfoTopPosition();
    this.handlePrintSelectionClick(false);
    this.handleClose();
    this.openModal(ModalType.CONTACT_INFO);
  }
  isRange(val_low, val_high) {
    return val_low != null && val_low != val_high && val_high && val_low;
  }
  suppressScheduleVisit() {
    return (
      [this.availableStatus.SOLD, this.availableStatus.RESERVED, this.availableStatus.FUTURE_HOME].includes(
        this.lotInfo.lot.status
      ) || this.isKioskMode
    );
  }

  get showSoldMessage(){
    return (
      [this.availableStatus.SOLD, this.availableStatus.FUTURE_HOME].includes(
        this.lotInfo.lot.status
      ) || this.isKioskMode
    );
  }
  bottomArrowCondition(xPosition: string, yPosition: string) {
    return (
      !this.hasMobile &&
      !this.hasTablet &&
      !!(
        this.lotPosition.xPosition === xPosition &&
        this.lotPosition.yPosition === yPosition
      )
    );
  }
  imageSource(src) {
    if (typeof src == "object" && src.image_url){
      return this.addScaler(src.image_url);
    }else {
      this.showDefaultImage = true;
      return require("@/assets/images/home-not-available.png");
    }
  }

  addScaler(url) {
    return addImageScaler(url);
  }

  checkLowRange(property1: string, property2:string, homePlan: HomesPlan){
    return (
           ![this.availableStatus.AVAILABLE, this.availableStatus.FUTURE_HOME].includes(this.lotInfo.lot.status) &&
            homePlan[property1] != null && homePlan[property1] ) ||
            [this.availableStatus.AVAILABLE, this.availableStatus.FUTURE_HOME].includes(this.lotInfo.lot.status) &&
            homePlan[property1] != homePlan[property2] && homePlan[property1];
  }
  
  updateModalPosition() {
    let lotElement = document.getElementById(this.lotId) as HTMLElement;
    const modelContainer = document.getElementById(
      "platmap-modal"
    ) as HTMLElement;
    let elementPosition = lotElement.getBoundingClientRect();
    const lotPosition = getPlatMapModalPosition(
      elementPosition,
      modelContainer.clientHeight,
      this.zoomLevel
    );
    if (!this.lodash.isEqual(this.lotPosition, lotPosition)) {
      this.updateLotPosition(lotPosition);
    }
  }
  start(event) {
    // event.preventDefault();
    if (event.touches.length === 2) {
      this.handlePinchStart(event);
    }
  }
  handlePinchStart(event) {
    const { x, y } = this.getTouchCenter(
      getTouchesCenter(event.touches[0], event.touches[1])
    );
    if (this.zoom < this.maxZoom) {
      this.zoomCenter.x = x;
      this.zoomCenter.y = y;
    }
    this.lastDistance = getZoomDistance(event.touches[0], event.touches[1]);
  }
  getTouchCenter({ x, y }) {
    const rect = this.$refs.baseElement.getBoundingClientRect();
    return {
      x: x - rect.left,
      y: y - rect.top,
    };
  }
  move(event) {
    // event.preventDefault();
    if (event.touches.length === 2) {
      this.handlePinchMove(event);
    } else {
      this.handlePanMove(event);
    }
  }
  handlePinchMove(event) {
    const zoom = getZoomDistance(event.touches[0], event.touches[1]);
    const last = zoom / this.lastDistance;
    const scale = calcZoom(
      this.minZoom - this.minZoomBounce,
      this.maxZoom + this.maxZoomBounce,
      this.zoom * last
    );
    if (
      this.zoom < this.maxZoom ||
      (this.zoom >= this.maxZoom && scale < this.zoom)
    ) {
      this.zoom = scale;
    }
    this.lastDistance = zoom;
  }
  checkRangeAndFutureHome(homePlan: HomesPlan){
    return this.isRange(homePlan.price_low, homePlan.price_high) && this.lotInfo.lot.status !== this.availableStatus.FUTURE_HOME
  }
  handlePanMove(event) {
    if (this.zoom > 1) {
      const touch = event.touches[0];
      const x = touch.clientX;
      const y = touch.clientY;
      if (!this.lastX || !this.lastY) {
        this.lastX = x;
        this.lastY = y;
        return null;
      } else {
        const rect = this.$refs.baseElement.getBoundingClientRect();
        let diffX = (x - this.lastX) * this.speed;
        let diffY = (y - this.lastY) * this.speed;
        this.transition.transform = null;
        //apply transform
        this.x += diffX;
        this.y += diffY;
        //bounds
        if (rect.left > 0 && diffX > 0) {
          this.x -= diffX;
        }
        if (rect.right < this.width && diffX < 0) {
          this.x -= diffX;
        }
        if (rect.top > 0 && diffY > 0) {
          this.y -= diffY;
        }
        if (rect.bottom < this.height && diffY < 0) {
          this.y -= diffY;
        }
        //to calc the next move
        this.lastX = x;
        this.lastY = y;
      }
    }
  }
  end(event) {
    // event.preventDefault();
    if (this.zoom <= this.minZoom) {
      this.resetZoom();
    } else {
      this.lastX = 0;
      this.lastY = 0;
    }
  }
  resetZoom() {
    this.zoom = 1;
    this.zoomCenter.x = 0;
    this.zoomCenter.y = 0;
    this.x = 0;
    this.y = 0;
  }
  get zoomStyles() {
    let transition = "";
    if (this.transition.transform) transition += this.transition.transform;
    if (this.transition.origin)
      transition +=
        (transition.length > 0 ? ", " : "") + this.transition.origin;
    return {
      transform: `scale(${this.zoom}) translate3d(${this.x}px, ${this.y}px, 0px)`,
      transition,
    };
  }
}
